import Feedback from './Feedback';

export default Feedback;



// WEBPACK FOOTER //
// ./src/Components/Feedback/index.tsx